export enum Themes {
    light = 'light',
    dark = 'dark',
}

/**TokenType using for login */
export enum TokenType {
    JWT = 'JWT',
    OTP_PWD = 'OTP_Password',
}

/**
 * 3rd party login method
 * @description Các phương thức login bên thứ 3
 */
export enum LoginMethod {
    Google = 'Google',
    Office365 = 'Office365',
    ADFS = 'ADFS',
    SSO = 'SSO',
}

export enum LanguageResourceTypes {
    System,
    Bussiness,
}

/**
 * Mã nghiệp vụ (BusinessCode) của các hệ thống bên thứ 3 có xử lý riêng khi
 * "Chuyển bộ phận chuyên môn" (xem [[emp_ForwardOutProcess]]):
 * - EO: hệ thống văn bản điều hành (trình ký) — file trình ký lấy theo
 *   cấu hình "Dùng file kết quả trả về" ở bước trước đó.
 * - HRM: hệ thống nhân sự — gửi kèm `Metadata` là data kết quả form câu
 *   hỏi động mà người nộp đã trả lời.
 *
 * Khớp với `SystemCode` trong danh mục hệ thống bên thứ 3 (xem
 * [[MOCK_THIRD_PARTY_SYSTEMS]]) — chỉ khai báo các mã cần xử lý đặc biệt.
 */
export enum ThirdPartySystemBusinessCode {
    EO = 'EOFFICE',
    HRM = 'HRM',
}

/**Các loại đối tượng, loại login */
export enum LoginTarget {
    /**Login cơ bản sử dụng tên tài khoản và mật khẩu từ hệ thống OG. Bao gồm cán bộ, khách vãng lai sử dụng,... */
    Credential = 'credential',
    /**Login của sinh viên sử dụng tên tài khoản và mật khẩu từ hệ thống UIS */
    UIS_Student = 'student',
    /**Vãng lai */
    Visitor = 'visitor',
    /**Đã có thông tin token thì cứ gọi hàm này để login */
    With_Token = 'token',
    /**Login với thông tin công dân */
    cust_info = 'cust_info',
}

export enum AppConfigCode {
    BusinessConfig = "BusinessConfig",
    AccountConfig = "AccountConfig",
    /** Cấu hình đơn vị vận chuyển Vietnam Post (MyVNPost) */
    MyVNPost = "MyVNPostApi",
    UISStudentApi = "UISStudentApi",
    /** Cấu hình API hóa đơn điện tử */
    EBillApi = "EBillApi",
    /** Tích hợp hệ thống khảo sát PSC ESurvey */
    ESurvey = "ESurvey",
}

/**Các loại đơn vị hành chính */
export enum AdministrativeUnitType {
    /**Tỉnh/thành phố */
    Province,
    /**Quận/huyện */
    District,
    /**Phường xã */
    Ward,
}

/**Enum sử udngj cho loại reset code là JWT hay OTP */
export enum ResetCodeType {
    /**ResetCode là OTP */
    OTP,
    /**
     * ResetCode là token JWT
     * @default
     */
    Token,
}

export enum SortValue {
    /**Tăng dần */
    ASC = 0,
    /**Giảm dần */
    DESC = 1,
}

export enum AuthRole {
    /**Quản trị viên */
    user = 'User',
    /**Khách hàng */
    customer = 'Customer',
    /**Quan tri. ONLY adminbak */
    admin = 'Administrator',
}

/**Expand của DossierNotifications */
export enum DossierNotificationsExpand {
    AppFileUploads = 'AppFileUploads',
}

/**
 * Sử dụng cho tagCodes FileUpload
 * @deprecated
 */
export enum TagCodeFileUpload {
    /** Update và lưu lại bởi công dân */
    PersonalFile = 'PersonalFile',
}

/**Sử dụng cho FilterCodes FileUpload */
export enum FilterCodeFileUpload {
    /**File cá nhân */
    Private = 'Private',
}

/**Loại đơn vị/phòng ban */
export enum PositionType {
    /**dùng chung */
    None = 0,
    /**phòng ban */
    Department = 1,
    /**đơn vị */
    DepartmentUnit = 2,
}

export enum DepartmentType {
    /**phòng ban */
    Department = 0,
    /**đơn vị */
    Unit = 1,
}

export enum OrganizationType {
    /**phòng ban */
    Department = 0,
    /**đơn vị */
    Unit = 1,
}

/**Expand using for getPage of StaffManagement */
export enum StaffExpand {
    Position = 'Positions',
    Department = 'Departments',
    WorkingGroups = 'WorkingGroups',
    EmployeeDetail = 'EmployeeInfos',
    Role = 'Roles',
}

/**Employee Expand */
export enum EmployeeExpand {
    Position,
    Department,
    Unit,
}

/**
 * Expand sử dụng khi get DossierPause
 * @deprecated
 */
export enum DossierPauseExpand {
    Detail,
}

/**Expand sử dụng khi getById Procedure */
export enum ProcedureGetByIdExpand {
    /**Quy trình */
    ImplementationProcess = 'ImplementationProcesses',
    /**Các bước */
    ImplementStep = 'ImplementationSteps',
    /**Phí */
    Fee = 'Fees',
    /**Phản hồi */
    Feedback = 'Feedbacks',
    /**Thành phần bổ sung */
    DossierComposition = 'DossierCompositions',
    /**File */
    File = 'Files',
}

/**Expan using for getById Department */
export enum DepartmentDetailExpand {
    Address = 'AppAddress',
}

/**Trạng thái thông báo */
export enum NotificationStatus {
    /**Đang hoạt động */
    InActive,
    /**Kích hoạt */
    Active,
    /**UwU */
    Unknown = -1,
}

/**loại hình xử lý */
export enum ProcessType {
    /** */
    Offline = 0,
    /** */
    Online = 1,
}

/**Hình thức xử lý */
export enum ProcessForm {
    /**Xử lý 1 Phần */
    Part = 0,
    /**Xử lý toàn phần */
    Full = 1,
}

/**Các trạng thái của thủ tục */
export enum ProcedureStatus {
    /**Thủ tục nháp */
    Draft = 0,
    /**Thủ tục chờ duyệt */
    WaitForApprove = 1,

    /**Thủ tục còn hiệu lực */
    TakeEffect = 2,
    /**Thủ tục hết hiệu lực */
    Expire = 3,
    /**Thủ tục đang sử dụng */
    InUse = 4,
}

/**Loại hình xử lý */
export enum ProcessingMethod {
    /**Trực tiếp */
    Offline,
    /**Trực tuyến */
    Online,
}

/**Hình thức xử lý (Đối với loại hình xử lý là trực tuyến) */
export enum ProcessingApproach {
    /**Một phần */
    Partial,
    /**Toàn phần */
    Full,
}

export enum CustomerType {
    /**Cá nhân */
    Individual = 'Individual',
    /**Doanh nghiệp */
    Organization = 'Organization',
    /**Khách vãng lai */
    Visitor = 'Visitor',

    /**
     * Thông tin khách hàng của nhân viên
     * Enum trên server không có này đâu, chỉ mock ở client
     */
    Staff = 'Staff',
}

/**Giới tính */
export enum Gender {
    /**Nam */
    Male = 1,
    /**Nữ */
    Female = 0,
    /**Khác */
    Other = 2,
}

/**Hình thức nộp - sử dụng cho hồ sơ */
export enum DossierSubmissonMethod {
    /**Trực tiếp tại nơi tiếp nhận hồ sơ */
    Direct = 1,
    /**Bưu chính - Nộp qua đường bưu điện */
    Postal = 2,
    /**Online - Nộp qua trang online của sinh viên/công dân */
    Internet = 3,
}

/**Hình thức giao trả - sử dụng cho hồ sơ */
export enum DossierHandoverMethod {
    /**Tại chỗ - Trả tại nơi tiếp nhận */
    Offline = 0,
    /**Trực tuyến -  */
    Online = 1,
    /**Bưu chính - Trả qua bưu điện */
    Post = 2,
}

/**Trường BelongToName sử dụng cho AppHoliday */
export enum HolidayBelongToName {
    Departments = 'Departments',
}

/**Trường BelongToName sử dụng cho WorkSchedule */
export enum WorkScheduleBelongToName {
    Departments = 'Departments',
}

/**
 * Type của address
 * @deprecated
 */
export enum AddressType {
    /**Không thuộc object nào */
    None = 0,
    /**Địa chỉ thuộc tài khoản USER */
    User = 1,
    /**Địa chỉ thuộc tài khoản khách hàng */
    Customer = 2,
    /**Địa chỉ của đơn vị/phòng ban */
    Department = 3,
}

export enum AddressDocumentCode {
    Customers = 'Customer_Infos',
}

/**Các nhãn nút chức năng của tạo, xử lý hồ sơ */
export enum DossierButtonAction {
    /** Cán bộ tiếp nhận (n) hồ sơ offline, chờ chuyển hồ sơ */
    EMP_Creates = 'EMP_CreatesAndWaitingTransfer',

    /**Cán bộ tiếp nhận hồ sơ hoàn thành */
    EMP_ReceiveCompleted = 'EMP_ReceiveCompleted',

    /**Cán bộ tiếp nhận online 1 hồ sơ của công dân */
    EMP_ReceiveOnline = 'EMP_ReceiveOnline',

    /**Cán bộ tiếp nhận nhiều hồ sơ online */
    EMP_ReceiveManyOnline = 'EMP_ReceiveManyOnline',

    /**Cán bộ tiếp nhận bổ sung hồ sơ */
    EMP_ReceiveAdditional = 'EMP_ReceiveAdditional',

    /**
     * Cán bộ in biên nhận và chuyển xử lý ngay sau khi tiếp nhận hồ sơ (online, offline).
     *
     * ?: Action này chỉ xảy ra khi hồ sơ vừa được tiếp nhận và nhân viên nhấn nút in biên nhận
     */
    EMP_PrintReceiptsAfterCreated = 'EMP_PrintReceiptsAfterCreated',

    /**
     * Cán bộ in biên nhận
     *
     * ? Action này chỉ sử dụng để bắt logic xử lý trên UI trên trang danh sách hồ sơ
     */
    EMP_PrintReceipt = 'EMP_PrintReceipt',

    /**Chuyển xử lý bước tiếp theo  */
    EMP_Forward = 'EMP_Forward',

    /**Chuyển lại bước xử lý trước */
    EMP_PrevForward = 'EMP_PrevForward',

    /**Giao việc */
    EMP_AssignTask = 'EMP_AssignTask',

    /**Truong phong Duyệt hồ sơ */
    EMP_ApproveDossier = 'EMP_ApproveDossier',

    /**Từ chối xử lý hồ sơ */
    EMP_RefuseDossier = 'EMP_RefuseDossier',

    /**Trả kết quả giao việc */
    EMP_ReturnAssignTask = 'EMP_ReturnAssignTask',

    /**Thu hồi giao việc */
    EMP_RevokeAssignTask = 'EMP_RevokeAssignTask',

    /**
     * Phối hợp xử lý a.k.a liên thông/xin ý kiến
     * @description Nút này được click khi nhân viên muốn gửi liên thông hoặc xin ý kiến, nhưng tùy vào loại gửi sẽ chọn đúng 1 trong 2 action để gửigửi
     */
    EMP_Coordination = 'EMP_Coordination',

    /**Gửi liên thông */
    EMP_SendConnection = 'EMP_SendConnection',

    /**Xin ý kiến */
    EMP_AskAdvise = 'EMP_AskAdvise',

    /**Trả kết quả liên thông */
    EMP_ReturnConnection = 'EMP_ReturnConnection',

    /**Trả kết quả xin ý kiến */
    EMP_ReturnAskAdvise = 'EMP_ReturnAskAdvise',

    /**Hủy phối hợp xử lý */
    EMP_CancelCoordination = 'EMP_CancelCoordination',

    /**Thu hồi lại xử lý đã chuyển */
    EMP_Revoke = 'EMP_Revoke',

    /**Nhân viên trả kết quả hồ sơ */
    EMP_ReturnResult = 'EMP_ReturnResult',
    /**Lưu nháp kết quả hồ sơ */
    EMP_SaveReturnResult = 'EMP_SaveReturnResult',
    /**Nhân viên trả kết quả hồ sơ có tạo bưu chính */
    EMP_ReturnResultWithPostal = 'EMP_ReturnResultWithPostal',

    /**Nhân viên thông báo cho người nộp/công dân */
    EMP_SendNotice = 'EMP_SendNotice',

    /**Nhân viên xem xử lý hồ sơ */
    EMP_ProcessingDetail = 'EMP_ProcessingDetail',

    /**Cán bộ sửa 1 hồ sơ đã tiếp nhận */
    EMP_Edit = 'EMP_Edit',

    /**Cán bộ hủy hồ sơ */
    EMP_Cancel = 'EMP_Cancel',

    /**Cán bộ y/c dừng tính hồ sơ */
    EMP_StopDossierToCouting = 'EMP_StopDossierToCouting',

    /**Trưởng phòng duyệt y.c bổ sung hồ sơ */
    EMP_DecisionStopCounting = 'EMP_DecisionStopCounting',

    /**Trưởng phòng từ chối y.c bổ sung hồ sơ */
    EMP_RefuseStopCounting = 'EMP_RefuseStopCounting',

    /**Nhân viên hủy y.c bổ sung hồ sơ */
    EMP_CancelStopCounting = 'EMP_CancelStopCounting',

    /**Trưởng phòng chuyển duyệt y.c bổ sung */
    EMP_ForwardRequestStopCounting = 'EMP_ForwardRequestStopCounting',

    /**Nhân viên tiếp tục xử lý sau khi dừng tính tại chỗ */
    EMP_ContinueHandle = 'EMP_ContinueHandle',

    /**
     * Chuyển bộ phận chuyên môn (hệ thống bên thứ 3, vd. EO - hệ thống
     * văn bản điều hành, HRM - hệ thống nhân sự...). Tương tự "Chuyển
     * bước tiếp theo" nhưng không chọn bước/người nhận — hồ sơ được gửi sang
     * hệ thống đã cấu hình sẵn cho bước (BusinessCode), người nhận cố định
     * là nhân viên hệ thống (xem [[SYSTEM_THIRD_PARTY_EMPLOYEE_ID]]).
     */
    EMP_ThirdPartySystem = 'EMP_ThirdPartySystem',

    // TODO:
    // /**Thay đổi người thụ lý cho bước xử lý chi tiết hồ sơ đã gửi */
    // EMP_ReAssignProcess = 'EMP_ReAssignProcess',

    //  Action liên thông ------------

    /**Tiếp nhận hồ sơ liên thông */
    EMP_ReceiveConnect = 'EMP_ReceiveConnect',

    /**Tiếp nhận hồ sơ xin ý kiến */
    EMP_ReceiveAskAdvise = 'EMP_ReceiveAskAdvise',
    /**Từ chối tiếp nhận hồ sơ liên thông */
    EMP_RefuseConnect = 'EMP_RefuseConnect',

    /**Từ chối tiếp nhận hồ sơ xin ý kiến*/
    EMP_RefuseAskAdvise = 'EMP_RefuseAskAdvise',

    /**Trả lời phối hợp ý kiến */
    EMP_ReturnCoordination = 'EMP_ReturnCoordination',

    /**Cán bộ đổi trạng thái hồ sơ*/
    EMP_SwitchStatus = 'EMP_SwitchStatus',
    /**Cán bộ in quyết định */
    EMP_PrintDecision = 'EMP_PrintDecision',
    /**Duyệt & Giao trả hồ sơ */
    EMP_FinishAndReturn = 'EMP_FinishAndReturn',
    /**Nhắc việc */
    EMP_SendRemind = 'EMP_SendRemind',

    //  Action bên dưới của Customer -----------------------

    /**Công dân tạo hồ sơ nháp */
    CUST_CreateDraft = 'CUST_CreateDraft',

    /**Công dân tạo hồ sơ */
    CUST_Create = 'CUST_Create',

    /**Công dân sửa hồ sơ*/
    CUST_Edit = 'CUST_Edit',

    /**Công dân bổ sung hồ sơ hồ sơ*/
    CUST_Additional = 'CUST_Additional',

    /**Công dân hủy nộp hồ sơ*/
    CUST_Cancel = 'CUST_Cancel',

    /**Công dân đổi trạng thái hồ sơ*/
    CUST_SwitchStatus = 'CUST_SwitchStatus',

    /**Công dân xóa hồ sơ*/
    CUST_Delete = 'CUST_Delete',

    /**Công dân xóa hồ sơ*/
    CUST_PrintReceipt = 'CUST_PrintReceipt',

    /**Công dân thanh toán hồ sơ*/
    CUST_Payment = 'CUST_Payment',

    /**Công dân in quyết định */
    CUST_PrintDecision = 'CUST_PrintDecision',
}

/**Các trạng thái của hồ sơ khi submit xuống API */
export enum DossierCustomerSubmitType {
    /**Trạng thái: NHÁP */
    Draft = 0,
    /**Trạng thái: CHỜ TIẾP NHẬN */
    Pending = 1,
}

/**Độ ưu tiên công việc khi chuyển xử lý */
export enum PriorityLevel {
    None,
    Low,
    Medium,
    High,
}

/**Các trạng thái của chi tiết xử lý hồ sơ (DossierDetailProcessStatuses) */
export enum DossierDetailProcessingStatus {
    /**Đang xử lý */
    Pending,
    /**Hoàn thành */
    Done,
    /**Thu hồi */
    Revoke,
    /**Kết thúc do hồ sơ đã hoàn thành */
    EndDueToCompletion,
}

/**
 * Trạng thái xử lý hồ sơ
 * @description Trạng thái xử lý hồ sơ khác với trạng thái hồ sơ
 *  */
export enum DossierStatus {
    /**Nháp */
    Draft,
    /**Chờ tiếp nhận */
    WaittingReceive,
    /**Tiếp nhận, chờ chuyển */
    ReceivedWaitingTransfer,
    /**Đang xử lý */
    Processing,
    /**Không xử lý */
    NotResolve,
    /**Chờ giao trả */
    WaitingForReturn,
    /**Đã giao trả */
    Returned,
    /**Hồ sơ từ chối tiếp nhận online — CBCC yêu cầu khách hàng soạn lại */
    RewriteRequirement,
}

/**
 * Trạng thái hồ sơ
 * @description Trạng thái xử lý hồ sơ khác với trạng thái hồ sơ
 *  */
export enum DossierCondition {
    /**Chưa có gì */
    None,
    /** Đang xử lý*/
    Processing,
    /**Hoàn thành */
    Finished,
    /** Không giải quyết*/
    NotResolved,
    /**Hồ sơ hủy */
    Cancel,
    /**Người nộp rút hồ sơ */
    Withdraw,
}

/**Trạng thái dừng tính của từng DossierSummaryProcess */
export enum SummaryPauseStatus {
    /**Dừng tính bổ sung hồ sơ */
    Additional,
    /**Lý do khác */
    OtherReason,
}

/**
 * Expand sử dụng cho hàm getPage Dossiers
 * @deprecated
 */
export enum DossierPageExpand {
    /**Lấy xử lý chi tiết xử lý chi tiết */
    Detail,
    /**Lấy xử lý chính */
    Main,
    /**Lấy phí */
    Fee,
}

/**Expand sử dụng cho hàm getDetail Dossiers */
export enum DossierDetailExpand {
    /**Lấy xử lý chính */
    Main = 'DossierSummaryProcesses',
    /**Lấy xử lý chi tiết xử lý chi tiết */
    Detail = 'DossierDetailProcesses',
    /**Lấy xử lý giao việc */
    AssignTask = 'AssignTasks',
    /**Lấy phí */
    Fee = 'DossierFees',
    /**Lấy thông tin dừng tính */
    Pause = 'DossierPauses',
    /**Lấy thông báo hồ sơ */
    Notification = 'DossierNotifications',
}

/**Expand sử dụng cho API /Dossiers/DocInfo */
export enum DocInfoExpand {
    /**Lấy lên file */
    File,
    /**Lấy lên thành phần bổ sung */
    Additional,
    /**Lấy lên nhưng thành phần bổ sung được duyệt */
    AcceptedAdditional,
}

/**Expand sử dụng cho DeclarationForm */
export enum DeclarationFormExpand {
    File = 'AppFileUploads',
}

/**Trạng thái của chi tiết dừng tính (DossierPauseDetail) */
export enum DossierPauseDetailStatus {
    Khong,
    Mot,
    Hai,
}

/**Type sử dụng cho DossierPause */
export enum DossierPauseType {
    /**Yêu cầu */
    Request,
    /**Chấp nhận */
    Approved,
    /**Từ chối */
    Reject,
    /**Hoàn thành */
    Finish,
    /**Tạm dừng */
    Cancel,
}

/**Lý do dừng tính hồ sơ */
export enum DossierPauseStatus {
    /**Bổ sung thêm hồ sơ */
    Additional,
    /**Dừng tính lý do khác */
    Other,
    /**Dừng tính nghĩa vụ tài chính  */
    StopDueToFinancialObligation,
    /**Chờ quyết định cấp thẩm quyền */
    StopDueToWaitingDecisionGiveAuthority,
}

/**Lấy trạng thái dừng tính của hồ sơ
 *  0  lấy hồ sơ bổ sung hay chưa
 */
export enum CustDossierPageExpand {
    IsSumbitAdditional,
    Fee,
    /**Lấy lên thông báo của hồ sơ */
    Notification,
}
/**Trạng thái xử lý giao việc */
export enum AssignTaskStatus {
    /**Đang xử lý */
    Pending,
    /**Hoàn thành */
    Done,
    /**Thu hồi */
    Revoke,
}

/** Type DossierSummaryProcessTypes */
export enum ForwardType {
    /**Không có */
    None,
    /**Luồng xử lý chính */
    Main,
    /**Luồng xử lý liên thông */
    Connect,
    /**Luồng xử lý xin ý kiến  */
    AskAdvice,
}

/**Trạng thái của DossierSummaryProcess */
export enum DossierSummaryProcessStatus {
    /**Chờ tiếp nhận */
    Waiting,
    /**Đang xử lý */
    Processing,
    /**Hoàn thành */
    Fininshed,
    /**Thu hồi xử lý*/
    Cancel,
    /**Từ chối xử lý */
    Refuse,
}

/**Các loại phí */
export enum FeeType {
    /**Phí */
    Fee,
    /**Lệ phí */
    Charge,
    /**Phí khác  */
    Other,
    /**Phí bưu chính */
    Postal,
}

/**Hình thức thanh toán phí */
export enum PayType {
    /** */
    None,
    /**Tiền mặt */
    Cash,
    /** */
    Cancel,
}

/**Action querystring của trang /cust-dossier */
export enum CustDossierDetailActionPage {
    /**Thanh toán */
    Payment = 'payment',
    /**Nộp bổ sung hồ sơ */
    Additional = 'additional',
}

/**Filter type sử dụng cho GetPage Employee nhân viên */
export enum DossierPageCodeFilter {
    // Công việc

    // TODO: Này chỉ là filter
    CV_QuanTrong = 'CV_QuanTrong',
    CV_DangXuLy = 'CV_DangXuLy',
    CV_DaChuyen = 'CV_DaChuyen',
    CV_DaNopChoTiepNhan = 'CV_DaNopChoTiepNhan',

    // Trạng thái hồ sơ
    TatCaTrangThaiNhan = 'TatCaTrangThaiNhan',
    HoSoSapDenHan = 'HoSoSapDenHan',
    DaTiepNhanChoChuyen = 'DaTiepNhanChoChuyen',
    DangXuLy = 'DangXuLy',
    DungTinh = 'DungTinh',
    ChoGiaoTra = 'ChoGiaoTra',
    DaGiaoTra = 'DaGiaoTra',
    TuChoiGiaiQuyet = 'TuChoiGiaiQuyet',
    HuyHoSo = 'HuyHoSo',
    DangChoKetQuaPhoiHop = 'DangChoKetQuaPhoiHop',
    HoSoQuaHan = 'HoSoQuaHan',
    LienThong = 'LienThong',

    // Others
    Dashboard = 'Dashboard',
}

export enum HeaderOTPTatic {
    /**
     * reset OTP cho hanh dong do
     */
    Reset,
    /**
     * Gửi validate OTP cho email
     * @default
     */
    Validate,
    /**Reset OTP with Custom mail */
    /**
     * Gửi validate OTP cho email cụ thể cấu hình trong headerheader
     * @default
     */
    ResetUsingRequestMail,
}

export enum DeclarationFormType {
    /**Mẫu đơn, tờ khai bình thường */
    None,
    /**Mẫu đơn, tờ khai quyết định */
    Decision,
}

export enum DeclarationFormTypeCodes {
    /**Là mẫu quyết định */
    Decision = 'DecisionForm',
}

/**
 * Key expand sử dụng cho API UISAcademicAdvisors
 */
export enum UISAcademicAdsitorExpand {
    StaffInfoByProfessor = 'StaffInfoByProfessor',
}

export enum DocumentNameImplementStepExecutor {
    Employee = 'Employee',
    Department = 'Department',
}

export enum WordOfWisdomDocumentName {
    AppTextTemplate = 'AppTextTemplates',
}

export enum WordOfWisdomDocumentCodeClone {
    DossierForwardToDepartment = 'DossierForwardToDepartment',
}

export enum AppTextTemplateType {
    Email,
    Text,
}

export enum AppBusinessReqDistributor {
    None,
    UIS,
    HRM,
    PORTAL,
}

export enum AdministrativeUnitVersion {
    /**Cấp hành chính 3 */
    Level3 = 1,
    /**Cấp hành chính 2 */
    Level2 = 2,
}

/**
 * Loại thủ tục
 * @description chuyển qua sử dụng động bắt theo ProcedureTypeStartingCodes
 */
export enum ProcedureTypes {
    /**
     * Thủ tục dành cho cán bộ
     */
    User = 1,
    /**
     * Thủ tục dành cho vãng lai
     */
    Visitor = 2,
    /**
     * Thủ tục dành cho sinh viên chính quy
     */
    Student_Regular = 3,
    /**
     * Thủ tục dành cho sinh viên vừa học vừa làm
     */
    Student_Working = 4,
}
/**
 * Loại thủ tục cho đối tượng bắt đầu bởi giá trị này 
 */
export enum ProcedureTypeStartingCodes {
    /**
     * loại thủ tục cho cán bộ
     */
    User = 'employee',
    /**
     * loại thủ tục cho khách vãng lai
     */
    Visitor = 'visitor',
    /**
     * loại thủ tục cho sinh viên
     */
    Student = 'student',
}

/**
 * @description chuyển qua sử dụng động bắt theo ProcedureTypeStartingCodes
 */
export enum StudentHTDT {
    /**
     * Sinh viên chính quy
     */
    CQ = 'SV_ChinhQuy',
    /**
     * Sinh viên vừa học vừa làm
     */
    VLVH = 'SV_VuaLamVuaHoc',
}

/**
 * Đối tượng gửi email khi giao trả hồ sơ
 */
export enum SendEmailToTypes {
    Customer = 0,
    Staff = 1,
}

export enum DossierPostalInformationType {
    /**
     * Tạo bởi công dân/sinh viên
     */
    Customer_Creation = 1,
    /**Tạo bởi cán bộ */
    Staff_Creation = 2,
}

export enum DossierPostalInformationStatus {
    /**Đơn mới khởi tạo ở trên onegate và chưa tạo thông tin bên đối tác vận chuyển */
    Initial = 1,
    /**Đã tạo thông tin bên đối tác vận chuyển */
    Sent = 2,
    /**Bị hủy */
    Cancelled = 3,
    /**Đã nhận kết quả */
    Received = 4,
}

export enum UserDraftDocumnentName {
    /**Hồ sơ */
    Dossiers = 'Dossiers',
}

/**Trạng thái của đánh giá chất lượng dịch vụ */
export enum UserServiceQualityStatuses {
    /**Mới tạo */
    New,
    /**Người dùng đã cập nhật nội dung phản hồi */
    Updated,
    /**CBCC đã review */
    Reviewed,
}

/**Các kiểu đánh giá chất lượng dịch vụ người dùng */
export enum UserServiceQualityRatingStyles {
    /**Đánh giá theo 1-5 sao */
    Stars,
    /**Đánh giá theo thang điểm 0-10 */
    Scale,
}

export enum UserServiceQualityCategory {
    Experience = 'Experience',
    Price = 'Price',
    Support = 'Support',
    Speed = 'Speed',
}

export enum UserServiceQualityDocumentName {
    /**Đánh giá chất lượng dịch vụ công của hồ sơ */
    Dossiers = 'Dossiers',
}
